import { v4 as uuidv4 } from 'uuid';

export const getUUID = () => uuidv4();

export const DEFAULT_CONTEXT_ID: string =
  '00000000-0000-0000-0000-000000000000';

export const DEFAULT_VERIFICATION_STATUS_ID: string =
  '00000000-0000-0000-0000-000000000000';
